import { PostData } from "@/types/types"
import { LatestNewsArticle } from "../types"

export const mapPostToArticle = (post: PostData): LatestNewsArticle => {
  const category = post.attributes?.categories?.data?.[0]

  return {
    id: post.id?.toString() || "",
    title: post.attributes?.title || "",
    slug: post.attributes?.slug || "",
    imageUrl: post.attributes?.cover?.data?.attributes?.url || post.attributes?.image?.data?.attributes?.url || "",
    publishedAt: post.attributes?.publishedAt || "",
    categoryName: category?.attributes?.name || "",
    categoryId: category?.id || "",
    views: post.attributes?.views || 0,
    locale: post.attributes?.locale,
  }
}
